
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospice/search/result",
      function () {
        return require("private-next-pages/hospice/search/result.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospice/search/result"])
      });
    }
  